<template>
  <div class="lt">
    <div class="lt-bottom" v-if="defaultdata && defaultdata.length">
      <div class="lt-bt-item" v-for="(item, index) in defaultdata.slice(0, 6)" :key="index" v-if="item && item.value1">
        <img src="../../assets/template/l1-btimg.png" alt="" class="bt-bg-img" />
        <img src="../../assets/template/l1-icon.png" alt="" class="bt-icon" />
        <div class="lt-item-title ellipsis" :title="item.value1">
          {{ item.value1 }}
        </div>
        <div class="lt-item-content">
          <div class="item-num">{{ item.value2 || 0 }}</div>
          <div class="item-unit" v-if="item.value3">{{ item.value3 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from './method.js'

export default {
  name: 'template.scope1',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      //线路列表
      topMap: [],
      select: {},
      // 已选高速详情列表 value1描述 value2蓝色字体 value3白色字体
      defaultdata: [
        { value1: '文本一', value2: '100', value3: '万元' },
        { value1: '文本二', value2: '200', value3: '万元' },
        { value1: '文本三', value2: '120', value3: '个' },
        { value1: '文本四', value2: '120', value3: '个' },
        { value1: '文本五', value2: '80', value3: '%' },
        { value1: '文本六', value2: '50', value3: '万' },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '数值', key: "value2" },
        { name: '单位', key: "value3" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {}
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
          let vlist = Object.keys(item)
          let isdata = false
          vlist.forEach(del => {
            if (item[del] == undefined) {
              item[del] = ''
            } else if (del && item[del]) {
              isdata = true
            }
          })
          if (vlist.length && isdata) return item
        })
        this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
  },
  methods: {
    ...methods
  },
  mounted() {
    this.setData()
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.lt {
  width: 435px;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
  overflow: hidden;
  // pointer-events: none !important;
  user-select: none !important;
  ;
  /* 禁止文本和图片被选中 */
}

.lt-bottom {
  margin: 0px 0 6px;
  height: 240px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-left: -36px;
}

.lt-bt-item {
  width: 146px;
  height: 114px;
  position: relative;
  margin-left: -2px;
}

.lt-bt-item:nth-child(3n + 1) {
  margin-left: 0;
}

.bt-bg-img {
  position: absolute;
  width: 194px;
  height: 114px;
}

.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 38px;
  top: 20px;
}

.lt-item-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #afc2df;
  line-height: 19px;
  position: absolute;
  top: 26px;
  left: 66px;
  width: 100px;
}

.lt-item-content {
  display: flex;
  position: absolute;
  top: 72px;
  left: 48px;
}

.item-num {
  font-family: Benmo-Ziyu;
  font-weight: 400;
  font-size: 22px;
  color: #3fc5ff;
  line-height: 19px;
}

.item-val {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #afc2df;
  line-height: 19px;
}

.item-unit {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a6bbd9;
  line-height: 19px;
  margin-left: 4px;
}
</style>
